import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    if (!token) {
        return <Navigate to="/login" />;
    }

    // Allow both staff and super admin access
    if (user.role !== 'staff' && user.role !== 'super_admin') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedRoute; 